var _mask, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfficePlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "office-placeholder_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 73,
    height: 73
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    rx: 6,
    fill: "#F4F4F4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#office-placeholder_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M0 0h73v73H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.45 50.834h6.533V21.678l-6.533 3.43v25.726zM43.85 30.253V25.19l13.883 11.842v-1.225l-16.66-17.314-13.556 6.37v4.165l-4.084 1.797v20.008h5.717V27.967h3.267v22.866h25.316v-1.715l-13.883-.735v-3.511l13.883 2.041v-1.388L43.85 42.503v-3.43l13.883 4.002v-1.388l-13.883-4.41v-4.655l13.883 7.105v-1.47L43.85 30.253z",
    fill: "#586876"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzMiIGhlaWdodD0iNzMiIHZpZXdCb3g9IjAgMCA3MyA3MyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swIiBtYXNrLXR5cGU9ImFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iNzMiIGhlaWdodD0iNzMiPgo8cmVjdCB3aWR0aD0iNzMiIGhlaWdodD0iNzMiIHJ4PSI2IiBmaWxsPSIjRjRGNEY0Ii8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMCkiPgo8cmVjdCB3aWR0aD0iNzMiIGhlaWdodD0iNzMiIGZpbGw9IiNGNEY0RjQiLz4KPC9nPgo8cGF0aCBkPSJNMTQuNDUgNTAuODMzNUgyMC45ODMzVjIxLjY3ODVMMTQuNDUgMjUuMTA4NVY1MC44MzM1WiIgZmlsbD0iIzU4Njg3NiIvPgo8cGF0aCBkPSJNNDMuODUgMzAuMjUzNFYyNS4xOTAxTDU3LjczMzMgMzcuMDMxN1YzNS44MDY3TDQxLjA3MzMgMTguNDkzNEwyNy41MTY3IDI0Ljg2MzRWMjkuMDI4NEwyMy40MzMzIDMwLjgyNTFWNTAuODMzNEgyOS4xNVYyNy45NjY3SDMyLjQxNjdWNTAuODMzNEg1Ny43MzMzVjQ5LjExODRMNDMuODUgNDguMzgzNFY0NC44NzE3TDU3LjczMzMgNDYuOTEzNFY0NS41MjUxTDQzLjg1IDQyLjUwMzRWMzkuMDczNEw1Ny43MzMzIDQzLjA3NTFWNDEuNjg2N0w0My44NSAzNy4yNzY3VjMyLjYyMTdMNTcuNzMzMyAzOS43MjY3VjM4LjI1NjdMNDMuODUgMzAuMjUzNFoiIGZpbGw9IiM1ODY4NzYiLz4KPC9zdmc+Cg==";
export { SvgOfficePlaceholder as ReactComponent };